<template>
  <div>
    <img :src="require('@/assets/emails/fb-icon.png')">
    <img :src="require('@/assets/emails/instagram-icon.png')">
    <img :src="require('@/assets/emails/logo.png')">
    <img :src="require('@/assets/emails/mail_top_image.png')">
    <img :src="require('@/assets/emails/twitter-icon.png')">
    <img :src="require('@/assets/emails/youtube-icon.png')">
  </div>
</template>

<script>

export default {
  name: 'EmailRendering',
};
</script>

<style lang="scss" scoped>
</style>
